import React from "react";
import { useSelector } from "react-redux";
import { AccountCircleOutlined } from "@mui/icons-material";
import useUserInfoStyles from "../css/useUserInfoStyles";

export default function UserInfo() {
  const userName = useSelector((state: any) => state.user.userName);
  const { classes } = useUserInfoStyles();

  return (
    <div className={classes.root}>
      <AccountCircleOutlined className={classes.icon} />
      <div className={classes.name}>{userName}</div>
    </div>
  );
}
